
import { Users, FileText, Activity, Database, Download } from 'lucide-react';

export interface ExportRequest {
  id: string;
  exportType: string;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  progress: number;
  createdAt: string;
  downloadUrl?: string;
}

export const exportTypes = [
  { value: 'users', label: 'User Data', icon: Users },
  { value: 'content', label: 'Content Analytics', icon: FileText },
  { value: 'activity', label: 'Activity Logs', icon: Activity },
  { value: 'system', label: 'System Metrics', icon: Database },
  { value: 'comprehensive', label: 'Full Platform Export', icon: Download }
];

export const availableTables = [
  'profiles', 'nodes', 'user_progress', 'ratings', 'node_comments',
  'admin_logs', 'security_events', 'site_analytics'
];

export const formats = [
  { value: 'csv', label: 'CSV' },
  { value: 'json', label: 'JSON' },
  { value: 'pdf', label: 'PDF Report' },
  { value: 'excel', label: 'Excel' }
];
